/**
 * Brew day's stages, in the day's order. The brewer says which one a brew is at with one tap, and its
 * readings say it too: a mash temperature typed means it is mashing at least (Tyler, 2026-10-06, after
 * the re-critique: "Should a brewer be able to say 'we're boiling' with one tap?").
 */
export const BREW_STAGES = ["pull", "mash", "boil", "fermenter"] as const;
export type BrewStage = (typeof BREW_STAGES)[number];

/** The further on of two stages, either of which may be unknown. */
export function laterStage(a: BrewStage | null, b: BrewStage | null): BrewStage | null {
  if (a === null) return b;
  if (b === null) return a;
  return BREW_STAGES.indexOf(a) >= BREW_STAGES.indexOf(b) ? a : b;
}
